import React, { useState } from 'react';
import { PageSliderStyled } from './Styled';

const PageSlider = (props: any) => {
  const { pages = [], defaultPage = 1, ...rest } = props;
  const [currentPage, setCurrentPage] = useState(defaultPage);

  const changePage = (page = defaultPage, scrollTop = true) => {
    setCurrentPage(page);

    if (scrollTop) {
      window?.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const nextPage = () => currentPage < pages.length && changePage(currentPage + 1);
  const prevBack = () => currentPage > 1 && changePage(currentPage - 1);
  const goPage = (page: number, scrollTop: boolean) => changePage(page, scrollTop);

  if (!pages.length) {
    return null;
  }

  const PageRender = pages[currentPage - 1];
  return (
    <PageSliderStyled>
      <PageRender nextPage={nextPage} prevBack={prevBack} currentPage={currentPage} goPage={goPage} {...rest} />
    </PageSliderStyled>
  );
};

export default PageSlider;
export { PageSlider };
